<template>
    <div>

        <el-select  :value="value" clearable placeholder="请选择" @input="setValue">
            <el-option :value="0" label="请选择"></el-option>
            <el-option
                    v-for="item in category_names"
                    :key="item.id"
                    :label="item.menu"
                    :value="item.id">
            </el-option>
        </el-select>
    </div>
</template>

<script>
    import{getArticleCategory} from "../../../request/api/article/article";
    export default {
        name: "SelectArticleCat",
        props:{
            value:{
                type:Number,
                default:0,
            },
        },
        data(){
            return{
                category_names:[],
            }
        },
        created(){
            this.getCategory_names();
        },
        methods:{
            setValue(e){
                this.$emit("input",e);
            },
            getCategory_names(){
                getArticleCategory({
                }).then(res => {
                    this.category_names=res.datas;
                }).catch(() => {

                })
            },
        },
    }
</script>

<style scoped>

</style>